import { mode } from "@chakra-ui/theme-tools";
import { BRAND, BRAND_SCALE } from "./brandColors";

export const globalStyles = {
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },
  colors: {
    brand: { ...BRAND_SCALE },
    brandScheme: { ...BRAND_SCALE },
    brandTabs: { ...BRAND_SCALE },
    secondaryGray: {
      100: "#e8edf2",
      200: "#dce6ee",
      300: "#eef3f7",
      400: "#e4eaf0",
      500: "#7a8ba8",
      600: "#6b7c96",
      700: "#4a5f78",
      800: "#3d5168",
      900: BRAND.navy,
    },
    red: {
      50: "#FEF2F2",
      100: "#FEEFEE",
      200: "#F8C9C5",
      400: "#F07B71",
      500: "#EE5D50",
      600: "#E31A1A",
    },
    blue: {
      50: "#EFF4FB",
      100: "#D6E4FF",
      200: "#B3C7FF",
      400: "#6B8AFF",
      500: "#3965FF",
      600: "#2B52D9",
    },
    orange: {
      100: "#FFF6DA",
      500: "#FFB547",
    },
    green: {
      100: BRAND.greenMuted,
      400: BRAND.greenLight,
      500: BRAND.green,
      600: BRAND.greenDark,
    },
    navy: {
      50: BRAND.greenMuted,
      100: "#c5d4e4",
      200: "#8fa8c4",
      300: "#5a7fa3",
      400: BRAND.navyLight,
      500: BRAND.navy,
      600: "#013a62",
      700: BRAND.navyDark,
      800: BRAND.navyDark,
      900: BRAND.navyDarker,
    },
    gray: {
      100: "#FAFCFE",
    },
  },
  semanticTokens: {
    colors: {
      "app.bg": {
        default: "secondaryGray.300",
        _dark: "navy.900",
      },
      "app.surface": {
        default: "white",
        _dark: "navy.800",
      },
      "app.text": {
        default: "secondaryGray.900",
        _dark: "white",
      },
      "app.muted": {
        default: "secondaryGray.600",
        _dark: "secondaryGray.400",
      },
      "app.border": {
        default: "gray.200",
        _dark: "whiteAlpha.200",
      },
    },
  },
  styles: {
    global: (props) => ({
      body: {
        overflowX: "hidden",
        bg: mode("secondaryGray.300", "navy.900")(props),
        color: mode("secondaryGray.900", "whiteAlpha.900")(props),
        fontFamily: '"Inter", "DM Sans", system-ui, -apple-system, sans-serif',
        letterSpacing: "-0.5px",
      },
      html: {
        fontFamily: '"Inter", "DM Sans", system-ui, -apple-system, sans-serif',
      },
      ".chakra-input, .chakra-textarea, .chakra-select": {
        color: mode("gray.800", "white")(props),
      },
      "input, textarea, select": {
        color: mode("gray.800", "white")(props),
        colorScheme: mode("light", "dark")(props),
      },
      "input[type='date'], input[type='time'], input[type='datetime-local']": {
        colorScheme: mode("light", "dark")(props),
      },
      "option": {
        bg: mode("white", "navy.800")(props),
        color: mode("gray.800", "white")(props),
      },
      "::selection": {
        bg: mode("brand.200", "brand.600")(props),
        color: mode("navy.900", "white")(props),
      },
    }),
  },
};
